//address type
export const pick_up = "1";
export const drop_off = "2";

export const TIMELINE_STATUS_OPTIONS = [
    // { label: "All Requests", value: "" },
    // { label: "New Request", value: "0" },
    // { label: "Bid submitted", value: "1" },
    // { label: "Bid accepted", value: "2" },
    // { label: "Awaiting Customer Response", value: "3" },
    // { label: "Direct Request Accepted", value: "3.1" },
    { label: "Truck assigned and ready to move", value: "4" },
    { label: "Move in progress", value: "5" },
    { label: "Completed, waiting for confirmation", value: "6" },
    { label: "Completed", value: "7" },
    { label: "Feedback Given", value: "8" },
  ];
//Customer Requests tab constants

export const active = "0";
export const completed = "1";
export const cancelled = "2";
